import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";
import { ConnectorConstant } from "./ConnectorConstant";

const initialState = {
  ConnectorDataList: [],
  Connectordataloading: {
    isLoading: false,
  },

  postConnectorList: [{}],
 
  postConnectorBulkList: [{}],
  deleteConnectorList: [{}],
};

export const ConnectorDataReducer = persistReducer(
  {
    storage,
    key: "Connectordata",
    whitelist: ["ConnectorDataList,postConnectorList,postConnectorBulkList"],
  },

  (state = initialState, { type, payload }) => {
    switch (type) {
      case ConnectorConstant.CONNECTOR_REQUEST: {
        return {
          ...state,
          ConnectorDataList: [],
          Connectordataloading: {
            isLoading: true,
          },
        };
      }

      case ConnectorConstant.CONNECTOR_RESPONSE: {
        return {
          ...state,
          ConnectorDataList: payload,
          Connectordataloading: {
            isLoading: false,
          },
        };
      }

      case ConnectorConstant.ADD_CONNECTOR_RESPONSE: {
        return {
          ...state,
          postConnectorList: payload,
          postConnector: {
            isLoading: false,
          },
        };
      }
      case ConnectorConstant.ADD_CONNECTOR_REQUEST: {
        return {
          ...state,
          postConnectorList: [],
          postConnector: {
            isLoading: true,
          },
        };
      }

      case ConnectorConstant.POST_CONNECTOR_BULK_REQUEST: {
        return {
          ...state,
          postConnectorBulkList: [],
        };
      }

      case ConnectorConstant.POST_CONNECTOR_BULK_RESPONSE: {
        return {
          ...state,
          postConnectorBulkList: payload,
        };
      }



      case ConnectorConstant.DELETE_CONNECTOR_REQUEST: {
        return {
          ...state,
          deleteConnectorList: [],
        };
      }

      case ConnectorConstant.DELETE_CONNECTOR_RESPONSE: {
        return {
          ...state,
          deleteConnectorList: payload,
        };
      }
      default:
        return state;
    }
  }
);
